import { NavLink } from "react-router";
import {
  Briefcase, CheckSquare, ClipboardList, FileText, FolderOpen, Home, Mail, Receipt, Settings, Users,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { usePermissions } from "@/hooks/use-permissions";

interface NavItem {
  to: string;
  label: string;
  icon: typeof Home;
  end?: boolean;
  claim?: string;
}

const items: NavItem[] = [
  { to: "/", label: "Dashboard", icon: Home, end: true },
  { to: "/enquiries", label: "Enquiries", icon: ClipboardList, claim: "enquiries:read" },
  { to: "/quotes", label: "Quotes", icon: FileText, claim: "quotes:read" },
  { to: "/jobs", label: "Jobs", icon: Briefcase, claim: "jobs:read" },
  { to: "/jobs/approvals", label: "Approvals", icon: CheckSquare, claim: "jobs:approve" },
  { to: "/invoices", label: "Invoices", icon: Receipt },
  { to: "/clients", label: "Clients", icon: Users },
  { to: "/artwork", label: "Artwork", icon: FolderOpen },
  { to: "/email", label: "Email", icon: Mail },
  { to: "/admin", label: "Admin", icon: Settings, claim: "admin:read" },
];

export function SideNav() {
  const { has } = usePermissions();
  const visible = items.filter((item) => !item.claim || has(item.claim));
  return (
    <nav aria-label="Main" className="w-64 shrink-0 border-r bg-background">
      <ul className="flex flex-col gap-1 p-2">
        {visible.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium",
                  isActive ? "bg-accent text-foreground" : "text-muted-foreground hover:bg-accent",
                )
              }
            >
              <item.icon className="size-4" />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
